import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import { TextWidth } from '@ta-interaktiv/react-disco-grid'

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]

  if (properties?.texts && typeof properties?.texts === 'string') {
    properties.texts = JSON.parse(properties.texts) as string[]
  }
  const type = properties?.type
  const texts = properties?.texts || [
    'Text wird für dieses MicroFrontend als Array übergeben. ["Absatz","Absatz","Absatz"]',
    '**Beginnt ein Array-Element mit "**" wird es bold',
    'Bisher gibt es folgende Textauszeichnungstypen: ',
    '**- note',
  ]
  console.log('Anmerkung', properties)
  return (
    <AppContainer className={globalClasses.join(' ')}>
      <TextWidth>
        <>
          {type && (
            <Wrapper className={type}>
              {texts &&
                (texts as string[]).map((p) => {
                  if (p.substring(0, 2) === '**')
                    return (
                      <p>
                        <b>{p.replace('**', '')}</b>
                      </p>
                    )
                  return <p>{p}</p>
                })}
            </Wrapper>
          )}
        </>
      </TextWidth>
    </AppContainer>
  )
}

const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`

const Wrapper = styled.div`
  margin-top: 30px;
  margin-bottom: 60px;

  &.note {
    opacity: 0.7;
    font-family: var(--font-sans-serif);
    font-size: 15px;
    letter-spacing: 0.4px;
    line-height: 1.4em;
    color: var(--text-color);
  }
`
export default MainComponent
